import React, { Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { haveAuth } from "utils"
import { hideFoodSidebar } from "@redux"
import FoodSidebarHeader from "./FoodSidebarHeader"
import FoodSidebarOrderDetails from "./FoodSidebarOrderDetails"
import FoodSidebarBottomBar from "./FoodSidebarBottomBar"
import FoodSidebarTotal from "./FoodSidebarTotal"
import FoodSidebarCheckoutButton from "./FoodSidebarCheckoutButton"
import FoodSidebarCheckoutAndPlaceOrderButtons from "./FoodSidebarCheckoutAndPlaceOrderButtons"
import FoodSidebarHoldAndRetrieveButtons from "./FoodSidebarHoldAndRetrieveButtons"
import classes from "./index.module.scss"

const FoodSidebar = () => {
  const i18n = useTranslation()[1]

  const dispatch = useDispatch()

  const pathname = useLocation().pathname

  const foodPageUiState =
    useSelector(state => state.foodPageUiState)

  const serviceTypeName =
    useSelector(state => state.systemSettings.serviceTypeName)

  const editMode =
    useSelector(state => !!state.orderForEditDetails)

  const showPlaceOrderButton =
    editMode ||
    serviceTypeName === "restaurant"

  const dir = i18n.dir(i18n.language)

  return (
    <Fragment>
      {
        foodPageUiState.sidebar &&
        <div
          onClick={() => dispatch(hideFoodSidebar())}
          className={classes["overlayer"]}
        />
      }

      <div
        className={dir === "ltr"
          ?
          clsx(
            classes["container-ltr"],
            pathname !== "/foods" && classes["hide-ltr"],
            foodPageUiState.sidebar && classes["open-ltr"]
          )
          :
          clsx(
            classes["container"],
            pathname !== "/foods" && classes["hide"],
            foodPageUiState.sidebar && classes["open"]
          )
        }
      >
        <FoodSidebarHeader />
        <FoodSidebarOrderDetails />
        <FoodSidebarBottomBar />
        <FoodSidebarTotal />
        <FoodSidebarHoldAndRetrieveButtons />
        {showPlaceOrderButton
          ?
          haveAuth(["placeOrder"]) &&
          <FoodSidebarCheckoutAndPlaceOrderButtons />
          :
          <FoodSidebarCheckoutButton />
        }
      </div>
    </Fragment>
  )
}

export default React.memo(FoodSidebar)